// src/data/clubs.js
// Source: CRMS Clubs & Organizations Google Site
// https://sites.google.com/leanderisd.org/crmsclubs/clubs-home
// Captured May 2026 — verify in August 2026 once the 26-27 club roster publishes.

import { SOURCES } from './sources.js';

export const clubs = [
  {
    id: 'ai-explorers',
    name: 'AI Explorers Club',
    shortName: null,
    description:
      'Learn about AI — what it is, how it works, and how to use it safely. Discussions cover AI applications across healthcare, transportation, retail, finance, entertainment, education, agriculture, and manufacturing.',
    grades: [6, 7, 8],
    meetingDay: 'Mon',
    meetingTime: '8:15 AM – 8:55 AM',
    meetingLocation: 'Room 0131',
    advisor: 'Lisa Thompson',
    advisorEmail: 'lisa.thompson@leanderisd.org',
    category: 'stem',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Meets twice a month.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'art-club',
    name: 'Art Club',
    shortName: null,
    description:
      'Open to all 6-8th grade students. A different art project each meeting. No cost to join.',
    grades: [6, 7, 8],
    meetingDay: 'Thu',
    meetingTime: '8:15 AM – 8:55 AM',
    meetingLocation: 'Main entrance pickup',
    advisor: 'Ansam Abouelela',
    advisorEmail: 'ansam.abouelela@leanderisd.org',
    category: 'arts',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes:
      'Last Thursday of each month. Late students cannot enter until 8:35 doors open and will miss the meeting. Class code: w77uvwb.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'cheerleading-club',
    name: 'Cheerleading',
    shortName: null,
    description:
      'Year-long commitment to cheer at football, basketball, pep rallies, and other school spirit events. Tumbling, stunts, jumps, and cheers practiced daily.',
    grades: [7, 8],
    meetingDay: 'Daily',
    meetingTime: 'During class period + practices',
    meetingLocation: null,
    advisor: 'Hannah Allred & Kate Martin',
    advisorEmail: 'hannah.allred@leanderisd.org',
    category: 'spirit',
    competitive: false,
    fieldTrips: null,
    requirements: 'Tryouts and coach recommendation required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'This is also a course (see Cheerleading 7711 in the Course Catalog). 7th-8th grade only.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'chess-club',
    name: 'Chess Club',
    shortName: null,
    description:
      'Learn chess strategies and openings, support friendly challenges between players. End-of-year tournament with possible prizes.',
    grades: [6, 7, 8],
    meetingDay: 'TBA',
    meetingTime: 'TBA',
    meetingLocation: null,
    advisor: 'Julie Haney',
    advisorEmail: null,
    category: 'special-interest',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: null,
    source: SOURCES.crmsClubs,
  },
  {
    id: 'computer-science-club',
    name: 'Computer Science Club',
    shortName: null,
    description:
      'Explore coding through puzzles, games, music, and web design. Year-end friendly competition to show off projects.',
    grades: [6, 7, 8],
    meetingDay: 'Tue',
    meetingTime: '8:15 AM – 8:55 AM',
    meetingLocation: null,
    advisor: 'Dana Verna',
    advisorEmail: 'dana.verna@leanderisd.org',
    category: 'stem',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'First Tuesday of every month.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'creative-writing-club',
    name: 'Creative Writing Club',
    shortName: null,
    description:
      'Short personal writing exercises that students can transform into podcasts, movies, or other published projects. Coordinates with other LISD middle schools for feedback and presentation opportunities.',
    grades: [6, 7, 8],
    meetingDay: 'Mon',
    meetingTime: '8:35 AM – 9:00 AM',
    meetingLocation: 'Library',
    advisor: 'Jamie Wright',
    advisorEmail: 'jamie.wright-sheriff@leanderisd.org',
    category: 'arts',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes:
      'Some Monday mornings only. Interest form requires Leander ISD account.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'destination-imagination',
    name: 'Destination Imagination',
    shortName: 'DI',
    description:
      'Creativity and team-based problem solving through Team and Instant Challenges. Teams of 3-7 students meet weekly after school September through March. Requires a parent team manager.',
    grades: [6, 7, 8],
    meetingDay: 'Varies',
    meetingTime: 'After school',
    meetingLocation: null,
    advisor: 'Seema George',
    advisorEmail: 'seema.george@leanderisd.org',
    category: 'academic',
    competitive: true,
    fieldTrips: 'Team and Instant Challenge competitions.',
    requirements: 'Parent team manager required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Meeting times set by individual team managers. Sept–March season.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'drama-club',
    name: 'Drama Club',
    shortName: null,
    description:
      'Student-led space for improv games, acting, and storytelling on stage. Creativity, teamwork, and confidence-building. Open to seasoned performers and newcomers.',
    grades: [6, 7, 8],
    meetingDay: 'Tue',
    meetingTime: '8:15 AM',
    meetingLocation: 'Back band door entrance',
    advisor: 'Brandy Roth',
    advisorEmail: 'brandy.roth@leanderisd.org',
    category: 'arts',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'New this year. Google Classroom code: otny3bu.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'dnd-club',
    name: 'Dungeons & Dragons Club',
    shortName: 'D&D',
    description:
      'Collaborative D20 game encouraging creativity, teamwork, communication, and socialization. Plan characters and campaigns for tabletop roleplaying. New and experienced players welcome.',
    grades: [6, 7, 8],
    meetingDay: 'Thu',
    meetingTime: '8:15 AM',
    meetingLocation: 'Room 1126 (Main Entrance pickup at 8:15)',
    advisor: 'Angelina Adams',
    advisorEmail: 'angelina.adams@leanderisd.org',
    category: 'special-interest',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: null,
    source: SOURCES.crmsClubs,
  },
  {
    id: 'eagle-allies',
    name: 'Eagle Allies',
    shortName: null,
    description:
      'Promotes acceptance, friendly environment, and kindness. Activities promote anti-bias, diversity, random acts of kindness, teamwork, inclusivity, problem-solving, leadership, and empathy. All are welcome.',
    grades: [6, 7, 8],
    meetingDay: 'TBA',
    meetingTime: 'TBA',
    meetingLocation: null,
    advisor: 'Miriam Eaves',
    advisorEmail: 'miriam.eaves@leanderisd.org',
    category: 'service',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Google Classroom code: ouii5lo.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'embroidery-club',
    name: 'Embroidery Club',
    shortName: null,
    description:
      'Student-run club to learn embroidery from scratch. Better to join early in the year for the complete experience. Open to all grades.',
    grades: [6, 7, 8],
    meetingDay: 'Mon',
    meetingTime: '8:20 AM',
    meetingLocation: '7th grade exterior doors',
    advisor: 'Charity Fedor',
    advisorEmail: 'charity.fedor@leanderisd.org',
    category: 'arts',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes:
      'Every other Monday — exact dates in Google Classroom (code d3xj72ie). Some Monday holidays affect schedule.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'fca',
    name: 'Fellowship of Christian Athletes',
    shortName: 'FCA',
    description:
      'Christian sports organization that uses athletics to impact community. Focuses on serving local communities through integrity, serving, teamwork, and excellence. Open to all students regardless of grade or athletic involvement.',
    grades: [6, 7, 8],
    meetingDay: 'Varies',
    meetingTime: 'TBA',
    meetingLocation: 'Small gym',
    advisor: 'Kristin Rangel & Kate Martin',
    advisorEmail: 'kristin.rangel@leanderisd.org',
    category: 'service',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes:
      'Fall meeting dates: 9/24, 10/8, 10/22, 11/5, 11/19, 12/3. Spring dates TBD.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'hosa',
    name: 'HOSA',
    shortName: 'HOSA',
    description:
      'Explore over 100 health careers. Develop leadership, teamwork, and high-tech health career skills. First year at CRMS.',
    grades: [6, 7, 8],
    meetingDay: 'TBA',
    meetingTime: 'TBA',
    meetingLocation: null,
    advisor: 'TBA',
    advisorEmail: null,
    category: 'stem',
    competitive: false,
    fieldTrips: null,
    requirements: 'Sign-up form required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Deadline to join: May 27, 2026.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'international-club',
    name: 'International Club',
    shortName: null,
    description:
      'Connect through language with students of all nationalities. Learn about different cultures via music, food, dance, and sport from around the world. Student-led.',
    grades: [6, 7, 8],
    meetingDay: 'Fri',
    meetingTime: '8:15 AM – 8:55 AM',
    meetingLocation: 'Room 117',
    advisor: 'TBD',
    advisorEmail: null,
    category: 'special-interest',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes:
      'Meets once or twice a month. Class code request via Google Form.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'intramurals',
    name: 'Intramurals',
    shortName: null,
    description:
      'After-school sports in a non-threatening, non-competitive atmosphere. Great for students not eligible for UIL competition or who want to learn a new sport. Currently hosting basketball and volleyball intramurals.',
    grades: [6, 7, 8],
    meetingDay: 'Varies',
    meetingTime: 'After school',
    meetingLocation: null,
    advisor: 'Austin Smith & Brenda Edwards',
    advisorEmail: 'austin.smith@leanderisd.org',
    category: 'spirit',
    competitive: false,
    fieldTrips: null,
    requirements: 'Permission slip required (separate slips for each sport).',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: null,
    source: SOURCES.crmsClubs,
  },
  {
    id: 'library-club',
    name: 'Library Club',
    shortName: null,
    description:
      'Help promote a love for reading on campus. Activities include team-building, crafts, library care, event planning, and prize drawings. Members help run Read-A-Thon, Family Trivia Night, Film Festival, Book Fair, and more. Form student-run "Lunch Bunch Book Clubs" and Lone Star Reading Rumble teams.',
    grades: [6, 7, 8],
    meetingDay: 'Fri',
    meetingTime: '8:15 AM – 8:55 AM',
    meetingLocation: 'Library',
    advisor: 'Jamie Wright',
    advisorEmail: 'jamie.wright-sheriff@leanderisd.org',
    category: 'service',
    competitive: false,
    fieldTrips: 'Read-A-Thon, Trivia Night, Film Festival, Maker Days.',
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'Once a month: 9/5, 10/3, 11/7, 12/5, 1/16, 2/6, 2/27 (Read-A-Thon only), 3/6 (Read-A-Thon only), 5/1. Late students can join when doors open at 8:35.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'math-counts',
    name: 'MATHCOUNTS',
    shortName: null,
    description:
      'Engaging math program building confidence and problem-solving for middle school students of all ability levels. Online competition series brings together students from all 50 states.',
    grades: [6, 7, 8],
    meetingDay: 'Tue',
    meetingTime: '8:10 AM',
    meetingLocation: 'Room 1129 (Main Entrance pickup)',
    advisor: 'Anjali Nayak',
    advisorEmail: 'anjali.nayak@leanderisd.org',
    category: 'academic',
    competitive: true,
    fieldTrips: 'MATHCOUNTS Competition Series.',
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Visit mathcounts.org for more information.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'math-pentathlon',
    name: 'Math Pentathlon',
    shortName: null,
    description:
      'Pentathletes think creatively, problem-solve, work cooperatively, and develop math skills.',
    grades: [6, 7, 8],
    meetingDay: 'TBA',
    meetingTime: 'TBA',
    meetingLocation: null,
    advisor: 'Anjali Nayak',
    advisorEmail: 'anjali.nayak@leanderisd.org',
    category: 'academic',
    competitive: true,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'Visit mathpentath.org for more information.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'njhs',
    name: 'National Junior Honor Society',
    shortName: 'NJHS',
    description:
      'Recognizes students for outstanding accomplishments in scholarship, character, leadership, citizenship, and service. Members exhibit academic achievement, citizenship, leadership, and admirable character.',
    grades: [7, 8],
    meetingDay: 'Tue, Thu',
    meetingTime: 'TBA',
    meetingLocation: null,
    advisor: 'Jessey Bantolo',
    advisorEmail: 'jesserene.bantolo@leanderisd.org',
    category: 'academic',
    competitive: false,
    fieldTrips: null,
    requirements: 'Application required. Academic, character, and service criteria apply.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'Assistant Adviser: Amy Alamar. Check NJHS website for exact dates.',
    source: SOURCES.crmsClubs,
    verificationNeeded: true,
    verificationNote:
      'CRMS clubs site lists NJHS without explicit grade restriction; NJHS is traditionally 7-8th. Confirm 6th-grade eligibility with adviser at orientation.',
  },
  {
    id: 'running-club',
    name: 'Running Club',
    shortName: null,
    description:
      'Open to all students 6-8. Improve fitness, prepare for Cross Country and Track & Field, or maintain current fitness level. Each practice: dynamic warm-up, 20-30 minutes of running, cool down. Locker room time before first class.',
    grades: [6, 7, 8],
    meetingDay: 'Varies',
    meetingTime: '7:30 AM',
    meetingLocation: 'Athletic doors entrance',
    advisor: 'Jared Lichtenberger',
    advisorEmail: 'jared.lichtenberger@leanderisd.org',
    category: 'spirit',
    competitive: false,
    fieldTrips: null,
    requirements:
      'Signed permission slip returned to Coach Edwards or Coach Lichtenberger before participating.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'Meeting dates: Oct 15, 16, 22, 23; Nov 5, 6, 12, 13, 19, 20; Mar 25, 26; Apr 1, 2, 8, 9, 15, 16, 22, 23, 29, 30. Bring water bottle, change of clothes, post-workout snack.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'robotics-fll',
    name: 'Robotics: First Lego League (FLL)',
    shortName: 'FLL',
    description:
      'Robotics program for 9-14 year olds, designed to get students excited about science and technology and teach valuable employment and life skills.',
    grades: [6, 7, 8],
    meetingDay: 'Varies',
    meetingTime: 'After school',
    meetingLocation: null,
    advisor: 'Veronica Romero',
    advisorEmail: 'veronica.romero@leanderisd.org',
    category: 'stem',
    competitive: true,
    fieldTrips: 'FLL competitions.',
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'Each team meets once after school per week. Teams typically full for current year — registration for next year begins in spring.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'robotics-ftc',
    name: 'Robotics: First Tech Challenge (FTC)',
    shortName: 'FTC',
    description:
      'Designed for grades 7-12 to compete head-to-head using a sports model. Teams design, build, and program robots to compete in alliance format. Reusable robot kit. Awards for competition, community outreach, design, and real-world accomplishments.',
    grades: [7, 8],
    meetingDay: 'Varies',
    meetingTime: 'After school + Saturdays',
    meetingLocation: null,
    advisor: 'Veronica Romero',
    advisorEmail: 'veronica.romero@leanderisd.org',
    category: 'stem',
    competitive: true,
    fieldTrips: 'FTC competitions.',
    requirements: 'Application and acceptance into the club required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes:
      'Grades 7-12 program — at CRMS, available to 7th and 8th. Teams typically full for current year — registration for next year begins in spring.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'science-fair',
    name: 'Science Fair',
    shortName: null,
    description:
      'Develop research and science exploration skills. School-wide Science Fair → regional → state. CRMS junior scientists have reached the state level every year. New this year: open to all 7th and 8th graders.',
    grades: [7, 8],
    meetingDay: 'Advisory class period',
    meetingTime: 'During school day',
    meetingLocation: null,
    advisor: 'Jessey Bantolo',
    advisorEmail: 'jesserene.bantolo@leanderisd.org',
    category: 'academic',
    competitive: true,
    fieldTrips: 'Regional and state science fair competitions.',
    requirements: 'Application required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: 'New this year — 7th and 8th grade only.',
    source: SOURCES.crmsClubs,
  },
  {
    id: 'science-olympiad',
    name: 'Science Olympiad',
    shortName: null,
    description:
      'Explore science across biology, engineering, and other domains. Solve challenges, work with friends, and represent CRMS in regional competitions.',
    grades: [6, 7, 8],
    meetingDay: 'Wed',
    meetingTime: '4:30 PM – 5:30 PM',
    meetingLocation: 'Room 0102',
    advisor: 'Jessey Bantolo',
    advisorEmail: 'jesserene.bantolo@leanderisd.org',
    category: 'stem',
    competitive: true,
    fieldTrips: 'Regional Science Olympiad competitions.',
    requirements: 'Application required.',
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: false,
    notes: null,
    source: SOURCES.crmsClubs,
  },
  {
    id: 'student-council',
    name: 'Student Council',
    shortName: 'StuCo',
    description:
      'Improves the school, community, and educational environment. Recognizes student needs, resolves problems, organizes school events, raises and spends money to benefit students, fosters leadership and responsibility. Open to all 6-8th grade students.',
    grades: [6, 7, 8],
    meetingDay: 'Wed',
    meetingTime: '8:20 AM',
    meetingLocation: 'Room 137 (front bike racks for early entry)',
    advisor: 'Kristen Cleaver & Ali Miller',
    advisorEmail: 'kristen.cleaver@leanderisd.org',
    category: 'service',
    competitive: false,
    fieldTrips: null,
    requirements: null,
    cost: null,
    permissionForm: true,
    capacity: null,
    highlight: true,
    notes: 'Google Classroom code: bjqhpeuw.',
    source: SOURCES.crmsClubs,
  },
];
